import { generateRepositoryMethods } from './repository.types.js';
export const dashboardRepositoryMethods = generateRepositoryMethods({
    getDashboardCoreData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/core',
    },
    getDashboardOrderCardData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/order-card',
    },
    getDashboardActionCardData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/action-card',
    },
});
//# sourceMappingURL=dashboard.methods.js.map